import {
  Box,
  Container,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";

import { Header } from "components";

const DATA = [
  {
    code: "a",
    noWords: 11,
    explanation: "article",
    examples: "the, a, your",
  },
  {
    code: "c",
    noWords: 38,
    explanation: "conjunction",
    examples: "if, because, whereas",
  },
  {
    code: "d",
    noWords: 34,
    explanation: "determiner",
    examples: "this, most, either",
  },
  {
    code: "e",
    noWords: 1,
    explanation: "existential",
    examples: "their",
  },
  {
    code: "g",
    noWords: 1,
    explanation: "genitive",
    examples: "'",
  },
  {
    code: "i",
    noWords: 96,
    explanation: "preposition",
    examples: "with, instead, except",
  },

  {
    code: "j",
    noWords: 839,
    explanation: "adjective",
    examples: "shy, risk, tender",
  },
  {
    code: "m",
    noWords: 36,
    explanation: "number",
    examples: "seven, fifth, two-thirds",
  },
  {
    code: "n",
    noWords: 2558,
    explanation: "noun",
    examples: "bulb, tolerance, slot",
  },
  {
    code: "p",
    noWords: 46,
    explanation: "pronoun",
    examples: "we, somebody, mine",
  },
  {
    code: "r",
    noWords: 333,
    explanation: "adverb",
    examples: "up, seldom, fortunately",
  },
  {
    code: "t",
    noWords: 1,
    explanation: "to + infinitive to",
    examples: "",
  },
  {
    code: "u",
    noWords: 12,
    explanation: "interjection",
    examples: "yeah, hi, wow",
  },
  {
    code: "v",
    noWords: 992,
    explanation: "verb",
    examples: "modify, scan, govern",
  },
  {
    code: "x",
    noWords: 2,
    explanation: "negation",
    examples: "not, n't",
  },
];

const LegendPage = () => {
  return (
    <>
      <Header />

      <Container maxW="container.lg" color="grayTxt">
        <Box
          as="h1"
          textAlign="center"
          color="grayTitle"
          fontSize="xl"
          my="1rem"
        >
          Legend
        </Box>
        <TableContainer>
          <Table variant="unstyled" size="sm">
            <Thead>
              <Tr>
                <Th padding="0.5rem 0.2rem">Code</Th>
                <Th padding="0.5rem 0.2rem">No. of Words</Th>
                <Th padding="0.5rem 0.2rem">Explanation</Th>
                <Th padding="0.5rem 0.2rem">Examples</Th>
              </Tr>
            </Thead>
            <Tbody>
              {DATA.map((o) => {
                return (
                  <Tr key={o.code}>
                    <Td padding="0.5rem 0.2rem">{o.code}</Td>
                    <Td padding="0.5rem 0.2rem">{o.noWords}</Td>
                    <Td padding="0.5rem 0.2rem">{o.explanation}</Td>
                    <Td padding="0.5rem 0.2rem">{o.examples}</Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
};

export default LegendPage;
